// extracted by mini-css-extract-plugin
export default {"mainTemplate":"logout-layout_mainTemplate__uliUj"};